// Third-party
import React, { CSSProperties } from 'react';

// Components
import ComparisonCardContent from './ComparisonCardContent';

// Types
import ComparisonItem from '@/types/comparison-item';
import Nullable from '@/types/nullable';
import User from '@/types/user';
import Comparison from '@/types/comparison';
import Portfolio from '@/types/portfolio';
import ComparisonCategory from '@/types/comparison-category';
import ComparisonField from '@/types/comparison-field';
import SelectedCategories from '@/types/selected-categories';
import RiskPeriods from '@/types/risk-periods';
import ComparisonHolding from '@/types/comparison-holding';
import Locale from '@/types/locale';

type Props = {
  item: ComparisonItem;
  sharingInfo?: Nullable<{ isMine: boolean; label: string }>;
  readOnly?: boolean;
  user?: User | null;
  comparison: Comparison;
  editedPortfolio?: Portfolio;
  onItemRemove: (item: ComparisonItem) => void;
  onModifyPortfolio: (item: ComparisonItem) => void;
  onViewPortfolio: (item: ComparisonItem) => void;
  onClonePortfolio: (item: ComparisonItem) => void;
  addCategoryBenchmark: (item: ComparisonItem) => void;
  onCloneBenchmark: (item: ComparisonItem) => void;
  onSavePortfolio: (item: ComparisonItem, toContact?: boolean) => void;
  categories: ComparisonCategory[];
  markupMode?: boolean;
  markupTool?: string;
  onCellClick: (item: ComparisonItem, category: ComparisonCategory, field: ComparisonField) => void;
  viewMarkup: boolean;
  selectedCategories?: SelectedCategories;
  setMarkupComment: (item: ComparisonItem, category: ComparisonCategory, field: ComparisonField, comment: string) => void;
  postMarkupComment: (item: ComparisonItem, category: ComparisonCategory, field: ComparisonField, dotNumber: number, comment: string) => void;
  getNewDotNumber: () => number;
  clearMarkup: (item: ComparisonItem, categoryKey: string, fieldKey: string, markupTool: string) => void;
  updateTableHeight: (height: number) => void;
  resizeCommentLinesContainer: () => void;
  riskPeriod: RiskPeriods;
  onShowCorrelation: (comparisonItem: ComparisonItem) => void;
  onExpandPortfolioItem: (item: ComparisonItem, expand: boolean) => void;
  previewMarkup?: boolean;
  getAdditionalCategoryStyles: (category: ComparisonCategory) => CSSProperties;
  allowExpandPortfolio: boolean;
  onModifyBenchmark: (item: ComparisonItem) => void;
  updateComparisonItemHolding: (item: ComparisonItem, holdingId: string, holdingData: Partial<ComparisonHolding>) => void;
  updateComparisonItemColor: (item: ComparisonItem, color: string) => void;
  popoverContainerRef: Nullable<HTMLDivElement>;
  scrollbarContainerRef?: HTMLElement;
  isSelected: boolean;
  hasStickyHeader?: boolean;
  onModifyGroup: (item: ComparisonItem) => void;
  locale?: Locale;
};

class ComparisonFXItem extends React.PureComponent<Props> {
  render() {
    const {
      item,
      user,
      readOnly,
      onCellClick,
      selectedCategories,
      comparison,
      markupMode,
      sharingInfo,
      onSavePortfolio,
      hasStickyHeader,
      scrollbarContainerRef,
      locale,
      ...rest
    } = this.props;

    return (
      <div className="comparison-fx-item">
        <div className="main-item">
          <ComparisonCardContent
            {...rest}
            user={user}
            item={item}
            onCellClick={onCellClick}
            selectedCategories={selectedCategories}
            comparison={comparison}
            markupMode={markupMode}
            sharingInfo={sharingInfo}
            onSavePortfolio={onSavePortfolio}
            allowExpandPortfolio
            scrollbarContainerRef={scrollbarContainerRef}
            hasStickyHeader={hasStickyHeader}
            locale={locale}
          />
        </div>

        <div className="expanded-sub-item">
          <ComparisonCardContent
            isFXSubItem
            showMenu={false}
            user={user}
            item={{ ...item, isFX: false }}
            onCellClick={onCellClick}
            selectedCategories={selectedCategories}
            comparison={comparison}
            markupMode={false}
            onSavePortfolio={onSavePortfolio}
            scrollbarContainerRef={scrollbarContainerRef}
            hasStickyHeader={hasStickyHeader}
            locale={locale}
            {...rest}
          />
        </div>
      </div>
    );
  }
}

export default ComparisonFXItem;
